export class TimeZoneModel {
  public id: string;
  public name: string;
  public displayName: string;
  constructor(id: string, name: string, displayName: string) {
    this.id = id;
    this.name = name;
    this.displayName = displayName;
  }

  static parse(obj: any): TimeZoneModel {
    if (!obj) return;
    return new TimeZoneModel(obj.id, obj.name, obj.displayName);
  }
}
